import React from "react";
import "./UnderConstruction.css";

const UnderConstruction = ({ language }) => {
  return (
    <div className="container">
      <h1>Lara und die Wand im Kopf</h1>
      <p className="subtitle">
        Ein Kinderbuch über Mut, Freundschaft und das Klettern
      </p>

      <section>
        <h2>Worum geht's?</h2>
        <p>
          Was passiert, wenn die größte Hürde nicht an der Wand, sondern im
          eigenen Kopf liegt? Lara ist neugierig, schüchtern – und plötzlich
          mitten in einer Kletterhalle, die ihr zunächst viel zu groß vorkommt.
          Doch mit jeder Route, jedem Sturz und jeder neuen Begegnung wächst sie
          über sich hinaus.
        </p>
        <p>
          <strong>„Lara und die Wand im Kopf“</strong> erzählt die Geschichte
          eines mutigen Mädchens, das das Klettern für sich entdeckt – mit all
          seinen Höhen und Tiefen. Für Kinder ab 9 Jahren – besonders für alle,
          die lernen möchten, sich selbst zu vertrauen.
        </p>
      </section>

      <section>
        <h2>Was erwartet dich?</h2>
        <ul>
          <li>
            Eine ehrliche und spannende Reise durch Chalk, Zweifel und kleine
            Siege
          </li>
          <li>
            Einfühlsame Einblicke in die Gedankenwelt einer jungen
            Kletteranfängerin
          </li>
          <li>
            Themen wie Mut, Freundschaft, Rückschläge – und das Wachsen daran
          </li>
          <li>Ideal für Leser*innen von ca. 9 bis 12 Jahren</li>
          <li>
            Mit einem besonderen Extra: <em>Laras Wand-Tagebuch</em> am Ende
            jedes Kapitels
          </li>
        </ul>
      </section>

      <section>
        <h2>Über den Autor</h2>
        <p>
          Stephan Hölscher ist Softwareentwickler, Vater und leidenschaftlicher
          Hobbykletterer. Inspiriert von seiner eigenen Tochter entstand die
          Idee für dieses Buch: Eine Geschichte, die junge Leserinnen nicht nur
          unterhält, sondern auch ermutigt – im Sport und im Leben.
        </p>
        <p>
          Mit einem Blick für emotionale Entwicklung und ehrlicher Sprache ist
          <strong> „Lara und die Wand im Kopf“ </strong> sein Kinderbuchdebüt.
        </p>
      </section>

      <section>
        <h2>Jetzt erhältlich</h2>
        <p>
          Das Buch ist als <strong>Taschenbuch</strong> und{" "}
          <strong>Kindle-E-Book</strong> bei Amazon erhältlich. Erlebe Laras Weg
          von der ersten Unsicherheit bis zur Freude am Klettern – und entdecke,
          wie stark man sein kann, wenn man an sich glaubt.
        </p>
        <p>
          Bei Fragen oder Anfragen rund um das Buch: <br />
          <a href="mailto:stephan@wandtagebuch.de">stephan@wandtagebuch.de</a>
        </p>
      </section>
    </div>
  );
};

export default UnderConstruction;
